module.exports = __webpack_public_path__ + "static/colgadas-017-ee5dd50ae218709941c459f4c4ebf7f9.jpg";